{
  "video_casting_invitation": "Video casting invitation",
  "project_summary": "Project summary",
  "project_description": "Project description",
  "number_of_shooting_days": "Number of shooting days",
  "date": "Date",
  "compensation": "Compensation",
  "image_rights": "Image rights",
  "instruction_casting": "Instructions for the video casting",
  "please_upload": "Please upload your video below before",
  "day": "day",
  "you_have": "You have been invited by Otakus to participate in a video casting for the following project:",
  "hi": "Hi",
  "date_start": "date start",
  "date_end": "date end",
  "send": "Send video cast",
  "title": "Send a video casting invitation to the selected candidates’ emails",
  "subTitle": "They will receive an email with the details of the work and the notes you include in the form below:",
  "send_invitation": "Send invitation",
  "field_required": "This field is required",
  "checking_invitation": "Checking your invitation, you will be redirected soon",
  "invitation_error": "This invitation dosen't exist or was already used",
  "success_title": "Congratulation.",
  "success_content": "You have successfully created an account, you can now continue to login.",
  "login": "Login",
  "invitations_list": "Invitations list",
  "email": "Email",
  "invitation": "Invitation"
}
